import React from "react";
import { Route, Routes } from "react-router-dom";
import QuickStartDocs from "./QuickStartDocs";
import DeploymentDocs from "./DeploymentDocs";
import OverviewDocs from "./OverviewDocs";
import I18nDocs from "./I18nDocs";
import MockBackendDocs from "./MockBackendDocs";
import CreateAPageDocs from "./CreateAPageDocs";
import UseADemo from "./UseADemo";

export default function DocsPage() {
  return (
    <Routes>
      <Route path="/quick-start" element={<QuickStartDocs />} />
      <Route path="/overview" element={<OverviewDocs />} />
      <Route path="/deployment" element={<DeploymentDocs />} />
      <Route path="/i18n" element={<I18nDocs />} />
      <Route path="/mock-backend" element={<MockBackendDocs />} />
      <Route path="/create-a-page" element={<CreateAPageDocs />} />
      <Route path="/use-a-demo" element={<UseADemo />} />
    </Routes>
  );
}
